<app-flat-card class="tw-mb-2 tw-block" customClasses="tw-py-4">
    <h3>
        <i class="uk-icon socio-icon {{ icon }}" *ngIf="icon"></i> {{ title }}
        <span *ngIf="description"
            >&nbsp;&nbsp;<b>{{ description }}</b></span
        >
    </h3>
</app-flat-card>
